import React from "react";
import Grid from "@material-ui/core/Grid";
import Aux from "../../../../hoc/Auxiliary/Auxiliary";
import {translation} from "../../../../I18n/i18n";

let Element = (props) => {
    return (
        <Aux>
            <br/>
            <Grid container>
                <Grid item xs={ 3 }>
                    <span className="MuiCardHeader-title">{translation(props.lang, "Opportunity")}</span>
                </Grid>
                <Grid item xs={ 9 }>
                    <span style={ {'color': 'rgba(0, 0, 0, 0.54)'} }>{ props.element.name._text }</span>
                </Grid>
            </Grid>
            <br/>
            <Grid container>
                <Grid item xs={ 3 }>
                    <span className="MuiCardHeader-title">Client</span>
                </Grid>
                <Grid item xs={ 9 }>
                    <span style={ {'color': 'rgba(0, 0, 0, 0.54)'} }>{ props.element.client.name._text }</span>
                </Grid>
            </Grid>
        </Aux>
    );
}

export default Element;